import {API_URL} from "../Config/config";
import { AuthService } from "./AuthService";
import {DateToUnixTimestamp} from "../Utils/DateHelper";

export class LezioniService {

    /**
   * Returns elements
   *
   * @param filter
   * @param paginate
   * @returns {Promise<any>}
   */
  getLezioni = (paginate,filters) => {
      let url = `${API_URL}lezione/read.php?timestamp=${DateToUnixTimestamp(new Date())}`;
      if(paginate){
        if(typeof paginate.first !== "undefined"){
          url += `&p_offset=${paginate.first}`;
        }
        if(typeof paginate.size !== "undefined"){
          url += `&p_size=${paginate.size}`;
        }
        if(typeof paginate.multiSortMeta !== "undefined"){
          url += `&p_sort=${JSON.stringify(paginate.multiSortMeta)}`;
        }
      }
      if(filters){
        url += `&filters=${JSON.stringify(filters)}`;
      }
      const requestOptions = {
          method: "GET",
          headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`}
      };
      return fetch(url,requestOptions).then(response => {
        if(response && response.status===200){
          return response.json();
        }
        else{
          return {isOk: false, total: 0, data: [], errorMessage: "error.generic"};
        }
      }).catch(error => {
        return {isOk: false, total: 0, data: [], errorMessage: "error.generic"};
      });
  }

  getLezione = (idlezione) => {
    let url = `${API_URL}lezione/single_read.php?timestamp=${DateToUnixTimestamp(new Date())}`;
    if(idlezione){
      url += `&idlezione=${idlezione}`;
    }
    const requestOptions = {
        method: "GET",
        headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`}
    };
    return fetch(url,requestOptions).then(response => {
      if(response && response.status===200){
        return response.json();
      }
      else{
        return {isOk: false, data: [], errorMessage: "error.generic"};
      }
    }).catch(error => {
      return {isOk: false, data: [], errorMessage: "error.generic"};
    });
  }

  deleteLezione = (idlezione) => {
      let url = `${API_URL}lezione/delete.php?timestamp=${DateToUnixTimestamp(new Date())}`;
      const requestOptions = {
        method: "DELETE",
        headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`},
        body: JSON.stringify({idlezione: idlezione})
      };
      return fetch(url,requestOptions).then(response => {
        if(response && response.status===200){
          return response.json();
        }
        else {
          return {isOk: false, errorMessage: "error.generic"};
        }
      }).catch(error => {
        return {isOk: false, errorMessage: "error.generic"};
      });
  }

  createLezione = (lezione) => {
      let url = `${API_URL}lezione/create.php?timestamp=${DateToUnixTimestamp(new Date())}`;
      const requestOptions = {
        method: "POST",
        headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`},
        body: JSON.stringify(lezione)
      };
      return fetch(url,requestOptions).then(response => {
        if(response && response.status===200){
          return response.json();
        }
        else {
          return {isOk: false, errorMessage: "error.generic"};
        }
      }).catch(error => {
        return {isOk: false, total: 0, data: [], errorMessage: "error.generic"};
      });
  }

  updateLezione = (lezione) => {
      let url = `${API_URL}lezione/update.php?timestamp=${DateToUnixTimestamp(new Date())}`;
      const requestOptions = {
        method: "POST",
        headers: { Authorization: `Bearer ${new AuthService().GetUserToken()}`},
        body: JSON.stringify(lezione)
      };
      return fetch(url,requestOptions).then(response => {
        if(response && response.status===200){
          return response.json();
        }
        else {
          return {isOk: false, errorMessage: "error.generic"};
        }
      }).catch(error => {
        return {isOk: false, total: 0, data: [], errorMessage: "error.generic"};
      });
    }

}
